import React from 'react'
import DatePicker from '../../../components/elements/DatePicker'
import GridCards from '../../../components/grid/GridCards'

import '../../../styles/scss/components/grid/grid.scss'

const GridContainer = () => {
  return (
    <div className="flow-events__grid">
      <div className="u-container">
        <div className="flow-events__grid-sidebar">
          <DatePicker />
        </div>
        <div className="flow-events__grid-content">
          <GridCards />
        </div>
      </div>
    </div>
  )
}

export default GridContainer
